// extracted by mini-css-extract-plugin
module.exports =  {"subtitle":"e3afc254ff--subtitle--JLuls","name":"e3afc254ff--name--_8YTD","section":"e3afc254ff--section--DeUwL"};